// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__etnp1","pulse":"styles_pulse__pwUhI","jump":"styles_jump__YsS4u"};